//# sourceMappingURL=cell.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/table/cell.interface.js
// module id = 1185
// module chunks = 4